import { getCustomTypography } from 'app/crud/programCustomTypography.crud';
import { applyCustomFonts } from 'app/services/fonts.service';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { put, takeLatest } from 'redux-saga/effects';
import { PERSIST_CUSTOM_TYPOGRAPHY, REDUCER_CUSTOM_TYPOGRAPHY } from '../conf';

export const actionTypes = {
  GetCustomTypography: 'cms/GET_CUSTOM_TYPOGRAPHY',
  SetCustomTypography: 'cms/SET_CUSTOM_TYPOGRAPHY',
};

const initialState = {
  customTypography: [],
  loading: false,
};

export const reducer = persistReducer({ storage, key: PERSIST_CUSTOM_TYPOGRAPHY, whitelist: ['customTypography'] }, (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GetCustomTypography:
      return { ...state, loading: true };

    case actionTypes.SetCustomTypography: {
      applyCustomFonts(action.payload);
      return { ...state, customTypography: action.payload, loading: false };
    }

    default:
      return state;
  }
});

export const selectors = {
  getCustomTypography: (state) => {
    return state.entities && state.entities[REDUCER_CUSTOM_TYPOGRAPHY] ? state.entities[REDUCER_CUSTOM_TYPOGRAPHY].customTypography : null;
  },
};

export const actions = {
  getCustomTypography: (params) => ({ type: actionTypes.GetCustomTypography, payload: { ...params } }),
  setCustomTypography: (response) => ({ type: actionTypes.SetCustomTypography, payload: response }),
};

function* fetchCustomTypography() {
  const { data, status } = yield getCustomTypography();
  if (data && status === 200) {
    yield put(actions.setCustomTypography(data));
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GetCustomTypography, fetchCustomTypography);
}
